import { type FC } from 'react'
import classNames from 'classnames'
import { type CustomWorkflowSummary } from '../../../store/customWorkflow/customWorkflows'
import { parseWorkflowTags } from '../../../components/CustomWorkflows/workflowTags'
import { ENTITY_TAGS } from '../../../components/CustomWorkflows/entityTags'
import { CategoryBadge } from '../../../components/CustomWorkflows/tags/CategoryBadge'
import { CategoryIcon } from '../../../components/CustomWorkflows/tags/CategoryIcon'
import { KindBadge } from '../../../components/CustomWorkflows/tags/KindBadge'
import { HashtagChips } from '../../../components/CustomWorkflows/tags/HashtagChips'
import { WorkflowCardFooter } from './WorkflowCardFooter'
import { WorkflowTile } from './WorkflowTile'
import styles from '../Workflows.module.scss'

interface ManualWorkflowCardProps {
  workflow: CustomWorkflowSummary
  onClick: () => void
  index?: number
}

export const ManualWorkflowCard: FC<ManualWorkflowCardProps> = ({ workflow, onClick, index }) => {
  const { category, kind, hashtags, entities } = parseWorkflowTags(workflow)
  const entity = entities[0] ?? null
  return (
    <WorkflowTile index={index} onClick={onClick}>
      <div className='d-flex align-items-start justify-content-between gap-2 w-100'>
        <CategoryIcon category={category} />
        <div className='d-flex flex-wrap gap-1 justify-content-end'>
          <KindBadge kind={kind} />
          <CategoryBadge category={category} />
        </div>
      </div>
      <div className='paragraph-small medium text-truncate w-100'>{workflow.name || workflow.id}</div>
      {workflow.description ? <div className={classNames('paragraph-small zocks-text-gray-700', styles.clampTwo)}>{workflow.description}</div> : null}
      <HashtagChips tags={hashtags} max={5} />
      <WorkflowCardFooter
        triggerType={workflow.triggerType}
        enablement='disabled'
        hasParameters={workflow.hasParameters}
        runFrom={entity === null ? null : ENTITY_TAGS[entity].runFrom}
      />
    </WorkflowTile>
  )
}
